/**
 * 
 */
class WMUFx extends EventTarget {

	/**
	 * 
	 */
	static type = '';

	/**
	 * Table des instances
	 */
	static instances = [];

	/**
	 * Table des éléments ayant une instance associé.
	 */
	static elements = [];

	/**
	 * 
	 */
	static instance( element, args = {} )
	{
		const index = this.elements.indexOf( element );

		if ( -1 !== index )
		{
			return this.instances[ index ];
		}
		else
		{
			const instance = new this( element, args );
			this.elements.push( element );
			this.instances.push( instance );
			return instance;
		}
	}

	/**
	 * 
	 */
	static deleteInstance( element )
	{
		const index = this.elements.indexOf( element );

		if ( -1 !== index )
		{
			const instance = this.instances[ index ];
			this.elements.splice( index, 1 );
			this.instances.splice( index, 1 );
			instance.clear();
		}
	}

	/**
	 * 
	 */
	constructor( element, args = {} )
	{
		super();

		this.element = element;
		this.inProgress = false;
	}

	/**
	 * 
	 */
	start()
	{

	}

	/**
	 * 
	 */
	stop()
	{

	}
}

export default WMUFx;
